import { db } from "../../firebase/firebase-config";
import { exportJSONToExcel, exportJSONToExcelConEstilos } from "../functions/exportJSONToExcel";

// Imprime productores que expidieron mas de su concesion #############################################################
// export const editarPermisos = async () => {
// 	const concesiones = await db
// 		.collection("padronesCultivos")
// 		.doc("2023-2024")
// 		.collection("padrones")
// 		.doc("ALFALFA")
// 		.collection("padron")
// 		.get();

// 	concesiones.forEach((concesion) => {
// 		if (concesion.data().supConcesion < concesion.data().supExpedida) {
// 			console.log(concesion.data());
// 		}
// 	});
// };

// Imprime exedicion de alfalfa por productor ##################################################################
// export const editarPermisos = async () => {
// 	const permisosSnap = await db
// 		.collectionGroup("permisos")
// 		.where("idProductorSelected", "==", "AAJL510901HGTLMN18")
// 		.where("ciclo", "==", "2024-2025")
// 		.get();

// 	const expedicion = {
// 		alfalfa: {},
// 		alfalfaNva: {},
// 		alfalfaR: {},
// 	};

// 	permisosSnap.forEach((permiso) => {
// 		if (permiso.data().estadoPermiso !== "Cancelado") {
// 			if (permiso.data().claveCultivo === 50) {
// 				if (expedicion.alfalfa[permiso.data().modulo]) {
// 					expedicion.alfalfa[permiso.data().modulo] =
// 						expedicion.alfalfa[permiso.data().modulo] + permiso.data().supAutorizada;
// 				} else {
// 					console.log(permiso.data().modulo);
// 					expedicion.alfalfa[permiso.data().modulo] = permiso.data().supAutorizada;
// 				}
// 			}

// 			if (permiso.data().claveCultivo === 51) {
// 				if (expedicion.alfalfaNva[permiso.data().modulo]) {
// 					expedicion.alfalfaNva[permiso.data().modulo] =
// 						expedicion.alfalfaNva[permiso.data().modulo] + permiso.data().supAutorizada;
// 				} else {
// 					expedicion.alfalfaNva[permiso.data().modulo] = permiso.data().supAutorizada;
// 				}
// 			}

// 			if (permiso.data().claveCultivo === 51.2) {
// 				if (expedicion.alfalfaR[permiso.data().modulo]) {
// 					expedicion.alfalfaR[permiso.data().modulo] =
// 						expedicion.alfalfaR[permiso.data().modulo] + permiso.data().supAutorizada;
// 				} else {
// 					expedicion.alfalfaR[permiso.data().modulo] = permiso.data().supAutorizada;
// 				}
// 			}
// 		}
// 	});

// 	console.log(expedicion);
// };

// Asigna localidad a permisos del 2023-2024 ##################################################################
// export const editarPermisos = async () => {
// 	const permisosSnap = await db
// 		.collectionGroup("permisos")
// 		.where("localidad", "==", "")
// 		.where("ciclo", "==", "2023-2024")
// 		.get();

// 	const localidadesSnap = await db.collection("colonias").get();

// 	const localidades = {};
// 	localidadesSnap.forEach((localidad) => {
// 		localidades[localidad.data().clave] = {
// 			nombre: localidad.data().nombre,
// 			tipo: localidad.data().tipo,
// 		};
// 	});

// 	// const tecnicosSnap = await db.collection("usuarios").where("rol", "==", "tecnicoCESVBC").get();

// 	// const tecnicos = [];
// 	// tecnicosSnap.forEach((tecnico) => {
// 	// 	tecnicos.push({
// 	// 		id: tecnico.id,
// 	// 		localidades: tecnico.data().localidades
// 	// 	});
// 	// });

// 	let batch = db.batch();
// 	let i = 1;
// 	const batchSize = 500;

// 	permisosSnap.forEach((permiso) => {
// 		// const tecnico = tecnicos.find((tecnico) =>
// 		// 	tecnico.localidades.includes(permiso.data().claveLocalidad)
// 		// );

// 		const localidad = localidades[permiso.data().claveLocalidad];

// 		// const permisoPrint = permiso.data();

// 		// console.log({ permisoPrint, localidad });
// 		// console.log(permiso.id);
// 		// console.log(permiso.data().claveLocalidad);
// 		// else console.log("sintecnico");
// 		// if (tecnico) {
// 		// 	console.log(tecnico.id);
// 		// 	console.log(permiso.data().claveLocalidad);
// 		// 	console.log(permiso.id);
// 		// }

// 		const ref = db
// 			.collection("permisos")
// 			.doc("2023-2024")
// 			.collection("modulos")
// 			.doc(`Modulo-${permiso.data().modulo}`)
// 			.collection("permisos")
// 			.doc(permiso.id);

// 		if (localidad) {
// 			batch.update(ref, {
// 				localidad: localidad.nombre,
// 				nombreLocalidad: localidad.nombre,
// 				tipoLocalidad: localidad.tipo,
// 			});
// 		}

// 		if (i === batchSize) {
// 			batch
// 				.commit()
// 				.then(() => {
// 					console.log("Se termino de subir batch");
// 				})
// 				.catch((err) => {
// 					console.error(err);
// 				});
// 			batch = db.batch();
// 			i = 0;
// 		}

// 		i++;
// 	});

// 	batch
// 		.commit()
// 		.then(() => {
// 			console.log("Se terminaron de editar los permisos");
// 		})
// 		.catch((err) => {
// 			console.error(err);
// 			console.log("Ya termino");
// 		});
// };

const HEADERS_EXPEDICION = {
	header: [
		"CICLO",
		"CLAVE_CULTIVO",
		"CLAVECULTIVO_ANTERIOR",
		"CLAVE_LOCALIDAD",
		"CUENTA",
		"CULTIVO_ANTERIOR",
		"CURP_PRODUCTOR",
		"ESTADO",
		"ESTADO_PERMISO",
		"FECHA_EMICION",
		"FECHA_LIMITE",
		"FUENTE_CREDITO",
		"LOCALIDAD",
		"LOTE",
		"MODULO",
		"MUNICIPIO",
		"NOMBRE_CULTIVO",
		"NOMBRE_LOCALIDAD",
		"NOMBRE_PRODUCTOR",
		"NUMERO_PERMISO",
		"OBSERVACIONES",
		"REACOMODO",
		"RFC_PRODUCTOR",
		"SECCION",
		"SISTEMA",
		"SUBCICLO",
		"SUP_AUTORIZADA",
		"SUP_DERECHO",
		"TIPO_PERMISO",
		"TIPO_LOCALIDAD",
		"TIPO_SEMILLA",
		"TRANSFERENCIA",
		"USUARIO",
		"VARIEDAD",
	],
};

const mapPermisoExpedicion = (permiso) => ({
	CICLO: permiso.data().ciclo,
	CLAVE_CULTIVO: permiso.data().claveCultivo,
	CLAVECULTIVO_ANTERIOR: permiso.data().claveCultivoAnterior,
	CLAVE_LOCALIDAD: permiso.data().claveLocalidad,
	CUENTA: permiso.data().cuenta,
	CULTIVO_ANTERIOR: permiso.data().cultivoAnterior,
	CURP_PRODUCTOR: permiso.data().curpProductor,
	ESTADO: permiso.data().estado,
	ESTADO_PERMISO: permiso.data().estadoPermiso,
	FECHA_EMICION: permiso.data().fechaEmicion.toDate().toLocaleDateString(),
	FECHA_LIMITE: permiso.data().fechaLimite.toDate().toLocaleDateString(),
	FUENTE_CREDITO: permiso.data().fuenteCredito,
	LOCALIDAD: permiso.data().localidad,
	LOTE: permiso.data().lote,
	MODULO: permiso.data().modulo,
	MUNICIPIO: permiso.data().municipio,
	NOMBRE_CULTIVO: permiso.data().nombreCultivo,
	NOMBRE_LOCALIDAD: permiso.data().nombreLocalidad,
	NOMBRE_PRODUCTOR: permiso.data().nombreProductor,
	NUMERO_PERMISO: permiso.data().numeroPermiso,
	OBSERVACIONES: permiso.data().observaciones,
	REACOMODO: permiso.data().reacomodo,
	RFC_PRODUCTOR: permiso.data().rfcProductor,
	SECCION: permiso.data().seccion,
	SISTEMA: permiso.data().sistema,
	SUBCICLO: permiso.data().subciclo,
	SUP_AUTORIZADA: permiso.data().supAutorizada,
	SUP_DERECHO: permiso.data().supDerecho,
	TIPO_PERMISO: permiso.data().tipo,
	TIPO_LOCALIDAD: permiso.data().tipoLocalidad,
	TIPO_SEMILLA: permiso.data().tipoSemilla,
	TRANSFERENCIA: permiso.data().transferencia,
	USUARIO: permiso.data().usuario,
	VARIEDAD: permiso.data().variedad,
});

// Descarga expedicion por ciclo y cultivo ######################################################################
export const descargaExpedicionPorCicloYCultivo = async (ciclo, claveCultivo, titulo) => {
	const permisosBatch = await db
		.collectionGroup("permisos")
		.where("claveCultivo", "==", claveCultivo)
		.where("ciclo", "==", ciclo)
		.where("estadoPermiso", "!=", "Cancelado")
		.get();

	const permisos = permisosBatch.docs.map(mapPermisoExpedicion);

	exportJSONToExcel(permisos, HEADERS_EXPEDICION, titulo, "JulioMolina", titulo);

	return permisos.length;
};

// Descarga expedicion de algodon y labores pendientes ######################################################################
export const descargaAlgodonLaboresPendientes = async (ciclo) => {
	const permisosBatch = await db
		.collectionGroup("permisos")
		.where("claveCultivo", "==", 80)
		.where("ciclo", "==", ciclo)
		.where("laboresPendientes", "==", true)
		.where("estadoPermiso", "!=", "Cancelado")
		.get();

	const permisos = permisosBatch.docs.map((permiso) => ({
		...mapPermisoExpedicion(permiso),
		LABORES_PENDIENTES: permiso.data().laboresPendientes,
	}));

	const titulo = `Labores_Pendientes_${ciclo}`;
	const headers = { header: [...HEADERS_EXPEDICION.header, "LABORES_PENDIENTES"] };

	exportJSONToExcel(permisos, headers, titulo, "JulioMolina", titulo);

	return permisos.length;
};

const COLOR_VERDE = "C6EFCE";
const COLOR_AMARILLO = "FFEB9C";

// Columna del excel -> columnas que forman su rango de expedicion
const RANGOS_EXPEDICION = {
	INICIOBC: { inicio: "INICIOBC", fin: "FINBC" },
	FINBC: { inicio: "INICIOBC", fin: "FINBC" },
	INICIOSONORA: { inicio: "INICIOSONORA", fin: "FINSONORA" },
	FINSONORA: { inicio: "INICIOSONORA", fin: "FINSONORA" },
};

// Fecha local en formato "YYYY-MM-DD", igual que las fechas guardadas en el cultivo
const fechaATexto = (fecha) => {
	const mes = String(fecha.getMonth() + 1).padStart(2, "0");
	const dia = String(fecha.getDate()).padStart(2, "0");
	return `${fecha.getFullYear()}-${mes}-${dia}`;
};

// Indica si hoy cae dentro del rango exacto (inicio y fin inclusive), con la misma regla que
// bloquearPorPeriodoDeExpedicion en NuevoPermisoScreen. Sin alguna de las fechas se considera fuera.
const fechaDentroDeRango = (inicio, fin, hoy) => {
	if (!inicio || !fin) return false;

	const hoyTexto = fechaATexto(hoy);
	return hoyTexto >= inicio && hoyTexto <= fin;
};

// Descarga el padron de cultivos ####################################################################################
export const descargaPadronCultivos = async () => {
	const headers = {
		header: [
			"CLAVE",
			"NOMBRE",
			"SUBCICLO",
			"COSTOHECTAREA",
			"COSTOGUIA",
			"INICIOBC",
			"FINBC",
			"INICIOSONORA",
			"FINSONORA",
			"CULTIVOCOMPLEMENTARIO",
		],
	};

	const cultivosBatch = await db.collectionGroup("cultivos").get();

	const cultivos = cultivosBatch.docs.map((cultivo) => ({
		CLAVE: cultivo.data().clave,
		NOMBRE: cultivo.data().nombre,
		SUBCICLO: cultivo.data().subciclo,
		COSTOHECTAREA: cultivo.data().costoHectarea,
		COSTOGUIA: cultivo.data().costoGuia,
		INICIOBC: cultivo.data().inicioBc,
		FINBC: cultivo.data().finBc,
		INICIOSONORA: cultivo.data().inicioSonora,
		FINSONORA: cultivo.data().finSonora,
		CULTIVOCOMPLEMENTARIO: cultivo.data().cultivoComplementario,
	}));

	const hoy = new Date();
	const getCellStyle = (row, header) => {
		const rango = RANGOS_EXPEDICION[header];
		if (!rango) return undefined;

		const dentro = fechaDentroDeRango(row[rango.inicio], row[rango.fin], hoy);

		return { fill: { patternType: "solid", fgColor: { rgb: dentro ? COLOR_VERDE : COLOR_AMARILLO } } };
	};

	exportJSONToExcelConEstilos(
		cultivos,
		headers,
		"PadronDeCultivos",
		"JulioMolina",
		"PadronDeCultivos",
		getCellStyle
	);

	return cultivos.length;
};

// Descarga lista de productores incumplidos ####################################################################################
export const descargaProductoresIncumplidos = async () => {
	const headers = {
		header: [
			"APMATERNO",
			"APPATERNO",
			"NOMBRE",
			"GENERO",
			"CURP",
			"RFC",
			"ESTADO",
			"MUNICIPIO",
			"DIRECCION",
			"CP",
			"TELEFONO",
			"FECHAREGISTRO",
			"INCUMPLIDO",
		],
	};

	const productoresBatch = await db.collectionGroup("productores").where("incumplido", "==", true).get();

	const productores = productoresBatch.docs.map((productor) => ({
		APMATERNO: productor.data().apMaterno,
		APPATERNO: productor.data().apPaterno,
		NOMBRE: productor.data().nombre,
		GENERO: productor.data().genero,
		CURP: productor.data().curp,
		RFC: productor.data().rfc,
		ESTADO: productor.data().estado,
		MUNICIPIO: productor.data().municipio,
		DIRECCION: productor.data().direccion,
		CP: productor.data().cp,
		TELEFONO: productor.data().telefono,
		FECHAREGISTRO: productor.data().fechaRegistro.toDate().toLocaleDateString(),
		INCUMPLIDO: productor.data().incumplido ? "Si" : "No",
	}));

	const titulo = `Productores_Incumplidos_${new Date().toISOString().slice(0, 10)}`;

	exportJSONToExcel(productores, headers, titulo, "JulioMolina", titulo);

	return productores.length;
};

// Modifica costo por hectarea de todos los cultivos ##################################################################
// export const editarPermisos = async () => {
// 	const cultivosSnap = await db.collectionGroup("cultivos").get();

// 	let batch = db.batch();
// 	let i = 1;
// 	const batchSize = 500;

// 	cultivosSnap.forEach((cultivo) => {
// 		const ref = db.collection("cultivos").doc(cultivo.id);

// 		batch.update(ref, { costoSanidades: 0 });

// 		if (i === batchSize) {
// 			batch
// 				.commit()
// 				.then(() => {
// 					console.log("Se termino de subir batch");
// 				})
// 				.catch((err) => {
// 					console.error(err);
// 				});
// 			batch = db.batch();
// 			i = 0;
// 		}

// 		i++;
// 	});

// 	batch
// 		.commit()
// 		.then(() => {
// 			console.log("Se terminaron de editar los cultivos");
// 		})
// 		.catch((err) => {
// 			console.error(err);
// 			console.log("Ya termino");
// 		});
// };

// Descarga expedicion permisos de pozos #########################################################################
export const descargaPermisosPozos = async (ciclo) => {
	const headers = { header: [...HEADERS_EXPEDICION.header, "P-CONTROL"] };

	const permisosBatch = await db
		.collectionGroup("permisos")
		.where("sistema", "in", ["Pozo Particular", "Pozo Federal"])
		.where("ciclo", "==", ciclo)
		.where("estadoPermiso", "!=", "Cancelado")
		.get();

	const permisos = permisosBatch.docs.map((permiso) => ({
		...mapPermisoExpedicion(permiso),
		"P-CONTROL": permiso.data().toma,
	}));

	const titulo = `Permisos_Pozos_${ciclo}`;

	exportJSONToExcel(permisos, headers, titulo, "JulioMolina", titulo);

	return permisos.length;
};

// Descarga padron de alfalfa nueva ######################################################################
export const descargaPadronAlfalfaNueva = async (ciclo) => {
	const headers = {
		header: [
			"ID_CONCESION",
			"ID_PRODUCTOR",
			"CURP",
			"NOMBRE",
			"CULTIVO",
			"MODULO",
			"CICLO",
			"SUP_CONCESION",
			"SUP_EXPEDIDA",
		],
	};

	const concesionesBatch = await db
		.collection("padronesCultivos")
		.doc(ciclo)
		.collection("padrones")
		.doc("ALFALFA NUEVA")
		.collection("padron")
		.get();

	const concesiones = concesionesBatch.docs.map((concesion) => ({
		ID_CONCESION: concesion.id,
		CICLO: concesion.data().ciclo,
		CULTIVO: concesion.data().cultivo,
		CURP: concesion.data().curp,
		ID_PRODUCTOR: concesion.data().idProductor,
		MODULO: concesion.data().modulo,
		NOMBRE: concesion.data().nombre,
		SUP_CONCESION: concesion.data().supConcesion,
		SUP_EXPEDIDA: concesion.data().supExpedida,
	}));

	const titulo = `PadronAlfalfaNueva_${ciclo}`;

	exportJSONToExcel(concesiones, headers, titulo, "JulioMolina", titulo);

	return concesiones.length;
};

// Muestra permisoa cancelados por modulo ######################################################################
export const getPermisosCanceladosPorModulo = async (ciclo, modulo) => {
	const usuariosBatch = await db.collection("usuarios").get();

	const usuarios = usuariosBatch.docs.map((usuario) => ({
		id: usuario.id,
		displayName: usuario.data().displayName,
		email: usuario.data().email,
	}));

	const permisosBatch = await db
		.collection("permisos")
		.doc(ciclo)
		.collection("modulos")
		.doc(`Modulo-${modulo}`)
		.collection("permisos")
		.where("estadoPermiso", "!=", "activo")
		.get();

	return permisosBatch.docs.map((permiso) => {
		const usuario = usuarios.find((usuario) => usuario.id === permiso.data().solicitanteCancelacion);

		return {
			numeroPermiso: permiso.data().numeroPermiso,
			ciclo: permiso.data().ciclo,
			estadoPermiso: permiso.data().estadoPermiso,
			cuenta: permiso.data().cuenta,
			usuario: permiso.data().usuario,
			nombreCultivo: permiso.data().nombreCultivo,
			supAutorizada: permiso.data().supAutorizada,
			usuarioSolicitante: usuario?.displayName ?? null,
			emailSolicitante: usuario?.email ?? null,
			fechaSolicitudCancelacion:
				permiso.data().fechaSolicitudCancelacion?.toDate().toLocaleDateString() ?? null,
		};
	});
};

// Muestra los permisos expedidos que evadieron labores fitosanitarias ###########################################
export const getPermisosFugitivos = async (cicloAnterior, cicloActual) => {
	const permisosAnterioresSnap = await db
		.collectionGroup("permisos")
		.where("claveCultivo", "==", 80)
		.where("ciclo", "==", cicloAnterior)
		.where("laboresPendientes", "==", true)
		.where("estadoPermiso", "!=", "Cancelado")
		.get();

	const permisosAnteriores = [];
	const permisosNuevosPromises = [];

	const usuariosSnap = await db.collection("usuarios").get();
	const usuarios = usuariosSnap.docs.map((usuario) => ({ ...usuario.data(), id: usuario.id }));

	permisosAnterioresSnap.forEach((permiso) => {
		permisosAnteriores.push({ ...permiso.data() });

		const permisosNuevosRef = db
			.collection("permisos")
			.doc(cicloActual)
			.collection("modulos")
			.doc(`Modulo-${permiso.data().modulo}`)
			.collection("permisos")
			.where("cuenta", "==", permiso.data().cuenta);

		permisosNuevosPromises.push(permisosNuevosRef.get());
	});

	const permisosNuevosResolved = await Promise.all(permisosNuevosPromises);
	const permisosFugitivos = [];

	permisosNuevosResolved.forEach((batch) => {
		batch.forEach((permisoNuevo) => {
			const arrayDePermisosAnteriores = permisosAnteriores.filter(
				(permisoAnterior) => permisoAnterior.cuenta === permisoNuevo.data().cuenta,
			);

			let stringDePermisosAnteriores = "";
			let stringTecnicosAnteriores = "";
			let stringSuperficiesParcialesLiberadasAnteriores = "";
			let cicloAnteriorEncontrado = "";

			arrayDePermisosAnteriores.forEach((permiso) => {
				const tecnico = usuarios.find((usuario) => usuario.id === permiso.tecnico);

				stringDePermisosAnteriores = `${stringDePermisosAnteriores}${permiso.numeroPermiso}*(${permiso.supAutorizada}ha) - `;
				stringTecnicosAnteriores = `${stringTecnicosAnteriores}${
					tecnico ? tecnico.displayName : false
				} - `;
				stringSuperficiesParcialesLiberadasAnteriores = `${stringSuperficiesParcialesLiberadasAnteriores}${permiso.superficieParcialLiberada} - `;
				cicloAnteriorEncontrado = permiso.ciclo;
			});

			permisosFugitivos.push({
				id: permisoNuevo.id,
				cultivo: permisoNuevo.data().nombreCultivo,
				ciclo: permisoNuevo.data().ciclo,
				tipo: permisoNuevo.data().tipo,
				sistema: permisoNuevo.data().sistema,
				modulo: permisoNuevo.data().modulo,
				cuenta: permisoNuevo.data().cuenta,
				expedida: permisoNuevo.data().supAutorizada,
				superficieParcialLiberada: stringSuperficiesParcialesLiberadasAnteriores,
				derecho: permisoNuevo.data().supDerecho,
				tecnico: stringTecnicosAnteriores,
				permisosAnteriores: stringDePermisosAnteriores,
				cicloAnterior: cicloAnteriorEncontrado,
			});
		});
	});

	return permisosFugitivos;
};

// Registra permisos ###########################################################################################
// export const editarPermisos = async () => {
// 	const permisos = [
// 		{
// 			numeroPermiso: "MOD9B-2000",
// 			cuenta: "10497.0",
// 			usuario: "ESTRADA GARCIA ERENDIDA Y+",
// 			modulo: "9B",
// 			claveLocalidad: 71,
// 			tipoLocalidad: "Colonia",
// 			nombreLocalidad: "MADERO",
// 			lote: "31",
// 			supAutorizada: 20
// 		},
// 		{
// 			numeroPermiso: "MOD11-2000",
// 			cuenta: "12455.0",
// 			usuario: "LOPEZ ANGULO ROSA",
// 			modulo: "11",
// 			claveLocalidad: 104,
// 			tipoLocalidad: "Colonia",
// 			nombreLocalidad: "SONORA",
// 			lote: "21",
// 			supAutorizada: 11.19
// 		},
// 		{
// 			numeroPermiso: "MOD11-2001",
// 			cuenta: "12767.0",
// 			usuario: "PALMERIN MEDRANO RAMON Y+",
// 			modulo: "11",
// 			claveLocalidad: 110,
// 			tipoLocalidad: "Colonia",
// 			nombreLocalidad: "V. CARRANZA",
// 			lote: "47",
// 			supAutorizada: 20
// 		},
// 		{
// 			numeroPermiso: "MOD17-2000",
// 			cuenta: "14635.0",
// 			usuario: "DE LA CERDA PIZANO LUIS",
// 			modulo: "17",
// 			claveLocalidad: 166,
// 			tipoLocalidad: "Ejido",
// 			nombreLocalidad: "HIDALGO",
// 			lote: "8",
// 			supAutorizada: 16.92
// 		},
// 		{
// 			numeroPermiso: "MOD21-2000",
// 			cuenta: "8436.0",
// 			usuario: "JIMENEZ BARRERA GABRIEL",
// 			modulo: "21",
// 			claveLocalidad: 211,
// 			tipoLocalidad: "Ejido",
// 			nombreLocalidad: "SOMBRERETE I",
// 			lote: "93",
// 			supAutorizada: 6.59
// 		}
// 	];

// 	try {
// 		permisos.forEach((permiso) => {
// 			console.log("Escribiendo: ", permiso.numeroPermiso);

// 			db.collection("permisos")
// 				.doc("2020-2021")
// 				.collection("modulos")
// 				.doc(`Modulo-${permiso.modulo}`)
// 				.collection("permisos")
// 				.doc(permiso.numeroPermiso)
// 				.set({
// 					...permiso,
// 					ciclo: "2020-2021",
// 					nombreCultivo: "ALGODONERO",
// 					estadoPermiso: "activo",
// 					claveCultivo: 80,
// 					barbechado: false,
// 					cosechado: false,
// 					desarraigado: false,
// 					desfoliado: false,
// 					desvarado: false,
// 					disqueado: false,
// 					laboresPendientes: true,
// 					pagado: false,
// 					superficieMapeada: 0,
// 					tecnico: false
// 				});
// 		});
// 	} catch (error) {
// 		console.log(error);
// 	}
// };

// Asigna tecnico a permisos del 2021-2022 ##################################################################
// export const editarPermisos = async () => {
// 	const permisosSnap = await db
// 		.collectionGroup("permisos")
// 		.where("claveCultivo", "==", 80)
// 		.where("ciclo", "==", "2021-2022")
// 		.get();

// 	const tecnicosSnap = await db.collection("usuarios").where("rol", "==", "tecnicoCESVBC").get();

// 	const tecnicos = [];
// 	tecnicosSnap.forEach((tecnico) => {
// 		tecnicos.push({
// 			id: tecnico.id,
// 			localidades: tecnico.data().localidades
// 		});
// 	});

// 	let batch = db.batch();
// 	let i = 1;
// 	const batchSize = 500;

// 	permisosSnap.forEach((permiso) => {
// 		const tecnico = tecnicos.find((tecnico) =>
// 			tecnico.localidades.includes(permiso.data().claveLocalidad)
// 		);
// 		// console.log(permiso.id);
// 		// console.log(permiso.data().claveLocalidad);
// 		// else console.log("sintecnico");
// 		// if (tecnico) {
// 		// 	console.log(tecnico.id);
// 		// 	console.log(permiso.data().claveLocalidad);
// 		// 	console.log(permiso.id);
// 		// }

// 		const ref = db
// 			.collection("permisos")
// 			.doc("2021-2022")
// 			.collection("modulos")
// 			.doc(`Modulo-${permiso.data().modulo}`)
// 			.collection("permisos")
// 			.doc(permiso.id);

// 		batch.update(ref, {
// 			laboresPendientes: true,
// 			tecnico: tecnico ? tecnico.id : false
// 		});

// 		if (i === batchSize) {
// 			batch
// 				.commit()
// 				.then(() => {
// 					console.log("Se termino de subir batch");
// 				})
// 				.catch((err) => {
// 					console.error(err);
// 				});
// 			batch = db.batch();
// 			i = 0;
// 		}

// 		i++;
// 	});

// 	batch
// 		.commit()
// 		.then(() => {
// 			console.log("Se terminaron de editar los permisos");
// 		})
// 		.catch((err) => {
// 			console.error(err);
// 			console.log("Ya termino");
// 		});
// };

// Homologa permisos de algodon del 2020-2021 con 2021-2022 ###########################################################
// export const editarPermisos = async () => {
// 	const permisosSnap = await db
// 		.collectionGroup("permisos")
// 		.where("cultivo", "==", "ALGODONERO")
// 		.where("ciclo", "==", "2020-2021")
// 		.get();

// 	let batch = db.batch();
// 	let i = 1;
// 	const batchSize = 500;

// 	// const permisos = [];
// 	permisosSnap.forEach((permiso) => {
// 		// console.log(permiso.data().claveLocalidad);
// 		// else console.log("sintecnico");
// 		// if (tecnico) {
// 		// 	console.log(tecnico.id);
// 		// 	console.log(permiso.data().claveLocalidad);
// 		// 	console.log(permiso.id);
// 		// }

// 		// permisos.push({
// 		// 	nombreCultivo: "ALGODONERO",
// 		// 	claveCultivo: 80,
// 		// 	numeroPermiso: permiso.data().folio,
// 		// 	estadoPermiso: "activo",
// 		// 	usuario: permiso.data().nombre,
// 		// 	supAutorizada: permiso.data().superficie,
// 		// 	nombreLocalidad: permiso.data().ubicacion
// 		// });

// 		const ref = db
// 			.collection("permisos")
// 			.doc("2020-2021")
// 			.collection("modulos")
// 			.doc(`Modulo-${permiso.data().modulo}`)
// 			.collection("permisos")
// 			.doc(permiso.id);

// 		batch.update(ref, {
// 			nombreCultivo: "ALGODONERO",
// 			claveCultivo: 80,
// 			numeroPermiso: permiso.data().folio,
// 			estadoPermiso: "activo",
// 			usuario: permiso.data().nombre,
// 			supAutorizada: permiso.data().superficie,
// 			nombreLocalidad: permiso.data().ubicacion
// 		});

// 		if (i === batchSize) {
// 			batch
// 				.commit()
// 				.then(() => {
// 					console.log("Se termino de subir batch");
// 				})
// 				.catch((err) => {
// 					console.error(err);
// 				});
// 			batch = db.batch();
// 			i = 0;
// 		}

// 		i++;
// 	});

// 	batch
// 		.commit()
// 		.then(() => {
// 			console.log("Se terminaron de editar los permisos");
// 		})
// 		.catch((err) => {
// 			console.error(err);
// 			console.log("Ya termino");
// 		});

// 	// console.log(permisos);
// };
